import { Component, OnInit } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { ButtonType } from 'src/app/utilities/enum';
import { AXErrorMessageDisplay, AXErrorMessages } from './../../../../models/formly.model';
import { VariableService } from './../../../../services/utilities/variables.service';

@Component({
    selector: 'app-grouping',
    templateUrl: './grouping.component.html',
    styleUrls: ['./grouping.component.scss'],
    standalone: false
})
export class GroupingComponent extends FieldType implements OnInit {

  formError: boolean = false;
  expandable: boolean;
  displayText: string = '';
  displayHeader: boolean = true;
  index = -1;
  errors: AXErrorMessages = { count: 0, errors: [], type: null };
  errorList: AXErrorMessageDisplay = {};
  buttonType = ButtonType;

  constructor(private readonly _variableService: VariableService) { super(); }

  ngOnInit(): void {
    const _t = this.field.fieldGroup;

    this.formError = this.form.controls[this.to.label]?.status === 'INVALID' ? true : false;

    if (this.to.description) {
      this.expandable = JSON.parse(this.to.description)?.expandable;
    }

    if (this.to.label === 'RefContactPersoonData') {
      this.displayHeader = false;
    }

    if (this.to.label && this.to.label.toLowerCase() === 'item') {
      this.displayText = (this.field['above'] ? this.field['above'] : 'Nieuwe') + ' ' + (parseInt(this.key.toString(), 0) + 1).toString();
    } else if (this.to?.label === '' && (!isNaN(Number(this.field.key)))) {
      this.displayText = (this.field['above'] ? this.field['above'] : 'Nieuwe') + ' ' + (parseInt(this.key.toString(), 0) + 1).toString();
    } else if (this.to.label && this.to.label !== '') {
      const _titleReplacement = this._variableService.axDisplayTextLookUpData.find(x => x.key.toLowerCase() === this.to.label.toLowerCase());
      if (_titleReplacement) {
        this.displayText = _titleReplacement.value;
      } else {
        this.displayText = this.to.label;
      }
    } else {
      const KEY = this.field.key;
      if (KEY) {
        const _titleReplacement = this._variableService.axDisplayTextLookUpData.find(x => x.key.toLowerCase() === KEY.toString().toLowerCase());
        if (_titleReplacement) {
          this.displayText = _titleReplacement.value;
        } else {
          this.displayText = KEY.toString();
        }
      }
    }
  }
}
